<template>

    <div id="document-share">
        <document-set-header v-bind:document-set="store.data.currentDocumentSet"></document-set-header>
        <div id="document-share-form" class="row" v-show="shareStatus == 'init'">
            <div class="document-list col-xs-12">
                <h3>Sending {{toShare.length}} document<span v-if="toShare.length!=1">s</span>:</h3>
                <div v-for="document in toShare" class="document well well-sm clearfix">
                    <span class="pull-left">{{ document.title }}</span>
                    <button class="btn btn-danger btn-xs action" @click="removeItem(document.id)"><i class="fa fa-ban"></i></button>
                </div>
            </div>
            <div class="recipients-block col-xs-12">
                <!-- <h3>Send {{toShare.length}} document<span v-if="toShare.length!=1">s</span> to:</h3> -->
                <h3>To:</h3>
                <div v-for="recipient in recipients">
                    <div class="form-group row">
                        <div class="recipient col-xs-12">
                            <input type="email" v-model="recipient.email" class="form-control" placeholder="Recipient email">
                            <button class="btn btn-danger btn-xs action removeRecipient" @click="removeRecipient(recipient)"><i class="fa fa-ban"></i></button>
                        </div>

                    </div>
                    <div v-if="errorMessage" class="alert alert-danger">{{errorMessage}}</div>
                </div>
                <div class="form-group">
                    <button class="btn btn-md btn-primary" @click="addRecipient"><i class="fa fa-plus-circle"></i> Add recipient</button>
                    <button v-if="recipients.length" class="btn btn-md btn-success" @click="processInvitation"><i class="fa fa-send"></i> Send</button>
                    <router-link :to="{ name: 'DocumentsView' }" class="btn btn-warning">Cancel</router-link>
                </div>
            </div>
        </div>
        <div id="document-share-status" class="row" v-show="shareStatus == 'success'">
            <div class="col-xs-12">
                <div id="success" class="alert alert-success">
                    <h2>Your documents have been shared.</h2>
                    <router-link :to="{ name: 'DocumentsView' }" class="btn btn-success">OK!</router-link>
                </div>
            </div>
        </div>
    </div>

</template>



<script>

    import APIService from '@/services/api.service'
    import DocumentSetHeader from '@/components/DocumentSetHeader'
    import DocumentSetsService from '@/services/document-sets.service'
    import DocumentSharingService from '@/services/document-sharing.service'
    import Q from 'q'
    import { Store } from '@/store.js'

    export default {
        
        name: 'documentsShare',
        
        data() {
            return {
                store: Store,
                recipients: [],
                invitationURL: '',
                deferred: [],
                errorMessage: false,
                shareStatus: 'init'
            }
        },
        
        created: function() {
            if (!this.store.data.currentDocumentSet.documents) {
                this.$router.push('/documents-view/'+this.setType+'/'+this.setId)
            }
            this.$data.recipients = [{
                email: ''
            }]
        },

        computed: {
            toShare: function() {
                if (!this.store.data.currentDocumentSet.documents) return []
                return this.store.data.currentDocumentSet.documents.filter( document => document.selected === true )
            },
            setId: function() { return this.$route.params.setId; },
            setType: function() { return this.$route.params.setType; }
        },
        
        components: {
            'document-set-header' : DocumentSetHeader
        },
        
        methods: {
            
            removeItem: function(id) {
                for (var i = this.$data.store.data.currentDocumentSet.documents.length - 1; i >= 0; i--) {
                    if (this.$data.store.data.currentDocumentSet.documents[i].id === id) {
                        this.$data.store.data.currentDocumentSet.documents[i].selected = false
                    };
                };
            },

            addRecipient: function() {
                this.recipients.push({
                    email: ''
                })
            },

            removeRecipient: function(val) {
                this.recipients = this.recipients.filter(function(el) {
                    return el !== val
                })
            },

            processInvitation: function() {
                return DocumentSharingService.postLimitedInvitation(this.setId, this.toShare, this.recipients)
                    .then(use.bind(this))

                function use(result) {
                    this.shareStatus = 'success'
                    return result
                }
            }
        }
    }
</script>



<style lang="scss" scoped>

    .document-list {
        font-size: 1rem;

        .document {
            text-align: left;
            padding-right: 3em;
            position: relative;

            .btn {
                position: absolute;
                top: 10px;
                right: 10px;
            }
        }
    }


    .recipient {
        position: relative;

        .form-control {
            width: calc(100% - 3em);
        }

        button {
            position: absolute;
            top: 5px;
            right: 25px;
        }
    }

</style>



// WEBPACK FOOTER //
// DocumentsShare.vue?7ae730e3